import type { EditorReadyOptions } from '@wix/platform-editor-sdk';

import { shouldEnableDependencyInstallationCheck } from '../utils/experiments';

export const isStandaloneInstallation = (options: EditorReadyOptions) => !options.origin.info?.appDefinitionId;

export const isDependencyInstallation = async (options: EditorReadyOptions) => {
  const isDependencyInstallationCheckEnabled = await shouldEnableDependencyInstallationCheck();

  if (!isDependencyInstallationCheckEnabled) {
    return false;
  }

  const isDependencyService = options.origin.initiator === 'Dependency_Service';
  return isDependencyService;
};
